import { TagVariant } from 'src/components/ColoredTag/styles'
import * as styles from './styles'
import ColoredTag from 'src/components/ColoredTag'

type GenericCardProps = {
  title: string
  tags: { label: string; variant: TagVariant }[]
  url: string
  linkMode?: 'wholeCard' | 'showMore'
  menu?: React.ReactNode
  className?: string
}

const GenericItemCard = ({
  title,
  tags,
  url,
  linkMode = 'wholeCard',
  menu,
  className
}: GenericCardProps) => {
  const card = (
    <styles.CardContainer
      hasHover={linkMode === 'wholeCard'}
      className={className}
    >
      <styles.LeftCol>
        <styles.CardHeaderContainer>
          <styles.TagsContainer>
            {tags.map((tag) => (
              <ColoredTag key={tag.label} variant={tag.variant}>
                {tag.label}
              </ColoredTag>
            ))}
          </styles.TagsContainer>
          <styles.CardTitle>{title}</styles.CardTitle>
        </styles.CardHeaderContainer>
        {linkMode === 'showMore' ? (
          <styles.Link to={url}>Ver Mais</styles.Link>
        ) : (
          <styles.ReadMoreLabel>Ver Mais</styles.ReadMoreLabel>
        )}
      </styles.LeftCol>
      {menu && <styles.RightCol>{menu}</styles.RightCol>}
    </styles.CardContainer>
  )

  if (linkMode === 'wholeCard') {
    return <styles.LinkC to={url}>{card}</styles.LinkC>
  }

  return card
}

export default GenericItemCard
